import { LocationStrategy, Location } from '@angular/common';
import { Component, OnInit, ViewChild, ChangeDetectorRef, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { MatMenuTrigger, MatPaginator, MatSort, MatTab, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { LabourJobService } from '../labour-job.service';
import { FilterService } from '../../services/filter.service';
import { UtilityService } from '../../services/utility.service';
import { DeleteConfirmModalComponent } from '../../commons/delete-confirm-modal/delete-confirm-modal.component';
import { AssetService } from '../../services/asset.service';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { JobHoursModelComponent } from 'src/app/time-sheet/learner-single-week/job-hours-model/job-hours-model.component';
import { saveAs } from "file-saver";

@Component({
  selector: 'labour-job-view',
  templateUrl: './labour-job-view.component.html',
  styleUrls: ['./labour-job-view.component.scss']
})
export class LabourJobViewComponent implements OnInit {

  @Input('jobFromClient') clientJob
  @Output() completionPercent: EventEmitter<any> = new EventEmitter<any>();
  displayedColumns: string[]
  dataSource: MatTableDataSource<any>;
  pageSize = 5;
  pageSizeOptions: number[] = [25, 50, 100];
  sort: MatSort;
  paginator: MatPaginator;
  jobId
  singleJobDetail
  hideTitle = false
  jobDocumentId
  selectedTab = 0
  user = JSON.parse(localStorage.getItem('userRoles'))
  currentUser = JSON.parse(localStorage.getItem('currentUser'))
  loading = false
  operativeList = []
  operativeListCopy = []
  isView = false
  afterFilter: any;
  filterActive = false
  isDocument = false
  isUserDocument = false
  selectedInstructorId
  selectedInstructors
  currentWeekDates = []
  isClientSign = false
  isOperativeSign = false
  clientSignature
  operativeSignature
  isDisabled = false
  clientError = false
  operativeError = false
  singleJobDates = []
  displayOperatives = []
  public contextMenuActions = [];
  contextMenuPosition = { x: '0px', y: '0px' };
  plannedTime: Object = { startTime: '', endTime: '' }
  operativeTimelogs = []
  jobDataList
  @ViewChild(MatMenuTrigger, { static: true })
  contextMenu: MatMenuTrigger;
  @ViewChild('staffTab', { static: true }) staffTab: MatTab;
  isDownload = false;
  linkedAsset = []
  searchText
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    private _router: Router,
    public _activatedRoute: ActivatedRoute,
    public _labourjobService: LabourJobService,
    private location: Location,
    private locationStrategy: LocationStrategy,
    private activatedRoute: ActivatedRoute,
    public _filter: FilterService,
    public _utilityService: UtilityService,
    public _assetService: AssetService,
    public _cd: ChangeDetectorRef
  ) {
    this.dataSource = new MatTableDataSource<any>([]);
  }

  ngOnInit(): void {
    this.getRequiredjobData()
    this._activatedRoute.params.subscribe(params => {
      this.jobId = params['jobid'];
      if (this.jobId != undefined) {
        this.getSingleLabourjob();
      }
    });
    if (this.user && (this.user.isAdmin || this.user.isManager)) this.displayedColumns = ['competency', 'operatives', 'action']
    else this.displayedColumns = ['competency', 'operatives']
  }


  ngOnChanges(changes: SimpleChanges) {
    console.log("CHANGES OF JOB ", changes);

    if (changes.clientJob && changes.clientJob.currentValue) {
      this.jobId = changes.clientJob.currentValue._id
      this.hideTitle = true
      this.getSingleLabourjob()
    }
  }

  // UTILITY

  updateData(jobs) {
    this.dataSource = new MatTableDataSource(jobs);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      // console.log("item", item, "property", property);
      switch (property) {
        case 'title': return item.competency.title;
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;

  }

  // Update query params details according to selected tab
  changeParams(event, test) {
    console.log("TAB CHANGE EVENET", event.index, test);
    this.selectedTab = event.index
    this.location.replaceState(
      this._router.createUrlTree(
        [this.locationStrategy.path().split('?')[0]], // Get uri
        { relativeTo: this.activatedRoute, queryParams: { currentTab: event.index }, queryParamsHandling: 'merge' }).toString()
    );
    this.manageTabs()

  }

  changeUserTabs(event, test) {
    if (this.user && this.user.isOperative) {
      console.log("TAB CHANGE EVENET", event.index, test);
      this.selectedTab = event.index
      this.location.replaceState(
        this._router.createUrlTree(
          [this.locationStrategy.path().split('?')[0]], // Get uri
          { relativeTo: this.activatedRoute, queryParams: { currentTab: event.index }, queryParamsHandling: 'merge' }).toString()
      );
      this.manageTabs()
    }
  }

  closeSidenav() {
    this._assetService.closeDisplayFile({ close: true })
  }
  opensidenav() {
    this.jobDocumentId = this.singleJobDetail.jobDocument
    console.log("CALL THIS OR NOT", this.user);

    if (this.user && (this.user.isAdmin || this.user.isClient || this.user.isManager)) this.isDocument = true
    if (this.user && this.user.isOperative) this.isUserDocument = true

    // this.isDocument = true
    setTimeout(() => {
      this.jobDocumentId = null
    }, 500);
  }

  // Search on competency name and user name
  filteronCompetency(searchText) {
    this.afterFilter = null
    this.filterActive = true;
    if (searchText === '') {
      this.filterActive = false;
      this.updateData(this.operativeList);
      return;
    }
    let tempDataSource = this._filter.labourjobFilter(searchText, this.operativeList, ['competency', 'operatives']);
    this.updateData(tempDataSource)
    if (tempDataSource.length <= 0) {
      this.afterFilter = {
        title: "No Users!",
        data: "Sorry, no user matched your search"
      }
    }
  }


  manageTabs() {
    if (this.user && (this.user.isAdmin || this.user.isClient || this.user.isManager)) {
      console.log("WHAT IS THE SELECTED tab", this.selectedTab);

      if (this.selectedTab != 3) this.closeSidenav()
      if (this.selectedTab == 3) this.opensidenav()
    }

    if (this.user && this.user.isOperative) {
      if (this.selectedTab != 1) this.closeSidenav()
      if (this.selectedTab == 1) this.opensidenav()
    }
  }

  // Add Signature of client and operative user
  addSignature(type, user?) {
    // console.log("BEFORE IMPLEMENT", this.clientSignature, this.operativeSignature);
    const dialogRef = this._utilityService.commonDialogBoxOpen(SignaturePadComponent, 'user')
      .afterClosed().subscribe((data) => {
        if (data == undefined) return
        if (type === 'client') {
          this.clientSignature = data
          this.clientError = false
        }
        if (type === 'operative') {
          // console.log("THIS IS FOR OPERATIVE", user, this.operativeList);
          let index = this.operativeList.findIndex((x) => {
            if (x && x.operatives) {
              console.log("WHAT IS IN THE X", x)
              if (x.operatives._id === user.operatives._id) return x
            }
          }
          )
          console.log("WHAT IS IN THE INDEX VALUE", index)
          if (index > -1) {
            this.operativeList[index]['operativeSignature'] = data
          }
          console.log("OPERATIVE LIST", this.operativeList)
        }
      })
  }

  displaySignature() {
    this.isDisabled = this.singleJobDetail.isSignature
    if (this.clientSignature && this.clientSignature != "") {
      this.isClientSign = true
      this.clientError = false
    }
  }

  onContextMenu(event: MouseEvent, item) {
    console.log("WHAT IS IN THE EVENT", event, item);

    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.menuData = { 'item': item };
    this.contextMenu.menu.focusFirstItem('mouse');
    this.contextMenu.openMenu();
  }

  showJobDetails(data) {
    console.log("THIS IS THE DATA", data);
    let value = { value: data }
    data = {
      data: value,
      isInstructor: true,
      type: 'adminSheet',
      isDisable: true
    }
    this._utilityService.commonDialogBoxOpen(JobHoursModelComponent, data).afterClosed()
  }


  // API CALL 

  // Add client and operative signature for individual job
  addSignatureData() {
    let obj = {
      clientSignature: this.clientSignature,
      operativeSignature: this.operativeList,
      jobId: this.singleJobDetail._id,
      // userId: this.currentUser._id
    }
    console.log("THIS IS THE OBJ TO BE SEND", obj);
    this._labourjobService.addJobSignature(obj).subscribe((res) => {
      console.log("Signature added", res);
      this.singleJobDetail = res.displayJobs[0]
      this.clientSignature = this.singleJobDetail.clientSignature
      this.operativeList = this.singleJobDetail.operatives
      this.displaySignature()
      this._utilityService.handleSnackBar({ msg: 'Signature Added successfully!', button: 'OK' })
    }, err => {
      this._utilityService.handleSnackBar({ msg: 'Something went wrong', button: 'OK' })
    })
    // }
  }


  removeOperative(job) {
    console.log("THIS IS THE REMOVE COMPETENCY", job);
    let obj = {
      jobId: this.singleJobDetail._id,
      removedId: job._id
    }
    const dialogRef = this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, 'user')
      .afterClosed().subscribe((data) => {
        if (data == '') return
        else if (data == 'yes') {
          this._labourjobService.removeUsers(obj).subscribe((removed) => {
            console.log("REMOVED USERS FROM JOB", removed);
            this.getSingleLabourjob()
          }, err => {
            console.log("ERROR WHILE REMOVED USER", err);
          })
        } else {
          return
        }
      })
  }


  // Get single labour job details
  getSingleLabourjob() {
    this.loading = true
    this._labourjobService.getSingleLabourjob(this.jobId).subscribe((res) => {
      this.singleJobDetail = res.displayJobs[0]
      this.clientSignature = this.singleJobDetail.clientSignature
      this.singleJobDates = this.singleJobDetail.singleJobDate
      this.operativeList = this.singleJobDetail.operatives
      this.displayOperatives = this.singleJobDetail.operativeList
      this.operativeTimelogs = this.singleJobDetail.operativeLogs
      if (this.operativeTimelogs && !this.operativeTimelogs.length) {
        this.isDownload = true
        console.log("THIS IS THE PLANNED TIME OF JOB", this.singleJobDetail, this.isDownload);
      }
      this.completionPercent.emit({ percent: this.singleJobDetail.completionPercent })
      this.linkedAsset = this.singleJobDetail.linkedAssets
      this.plannedTime = { startTime: this.singleJobDetail.startTime, endTime: this.singleJobDetail.endTime }
      if (this.user && this.user.isOperative && this.singleJobDetail.singleJobDate && this.singleJobDetail.singleJobDate.length) {
        this.selectedInstructorId = this.currentUser._id
        this.currentUser['userId'] = { _id: this.currentUser.userId }
        this.selectedInstructors = this.currentUser
        this.singleJobDetail.singleJobDate.filter((x) => { this.currentWeekDates.push(x.date) })
      }
      if (this.user && this.user.isOperative) this.displaySignature()
      this.activatedRoute.queryParams.subscribe(qparams => {
        console.log("QP PARAMS DATA", qparams);
        this.selectedTab = qparams['currentTab']
        this.manageTabs()
      })
      this.updateData(this.operativeList)
      if (this.operativeList && !this.operativeList.length) {
        this.filterActive = true
        this.afterFilter = {
          title: "No Users!",
          data: "Sorry, no user added to this job"
        }
      }
      this.loading = false
    }, err => {
      console.log("ERROR WHILE GET SINGLE LABOUR JOB", err);
      this.loading = false
    })
  }

  getRequiredjobData() {
    // this.loading = true
    this._labourjobService.getRequiredjobData('test2').subscribe((data) => {
      console.log("THIS IS THE PLANNED TIME OF JOB", data)
      this.jobDataList = data
      // this.loading = false
    }, error => {
      console.log("ERROR WHILE GET DATA", error);
      // this.loading = false
    })
  }

  downloadTimesheet(format) {
    this.isDownload = true
    let obj = {
      logs: this.displayOperatives,
      jobDetails: this.singleJobDetail,
      jobId: this.singleJobDetail._id,
      format: format
    }
    this._labourjobService.downloadTimesheet(obj).subscribe((data) => {
      console.log("THIS IS THE TIME SHEET DATA TO DOWNLOAD", data);
      if (format === 'pdf') {
        const byteArray = new Uint8Array(data.bufferData.data);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        saveAs(blob, this.singleJobDetail.jobTitle);
      }
      else {
        console.log("CALL THIS ELSE PART", data)
        const downloadLink = document.createElement("a");
        // const fileName = title + ".zip";
        downloadLink.href = data;
        downloadLink.download = this.singleJobDetail.jobTitle + '-timesheet'
        downloadLink.click();

        // saveAs(data, this.singleJobDetail.jobTitle);
      }
      this._utilityService.handleSnackBar({ msg: 'Timesheet Download Successfully', button: 'OK' })
      this.isDownload = false
    }, error => {
      console.log("ERROR0 ", error);
      this.isDownload = false
    })
  }
}
